export default __webpack_public_path__ + "static/media/noBackgroundWithBorder.06396d78.svg";